import {NOTIFICATION_TYPE_REQUEST, NOTIFICATION_TYPE_SHOW, NOTIFICATION_TYPE_EDIT, NOTIFICATION_TYPE_CLEAR, NOTIFICATION_TYPE_FAIL} from "../store/config";

const notificationTypiInit ={
	isFetching: false,
	list: [],
	edit:{},
	pages: {
		current: undefined,
		per_page: undefined,
		total: undefined
	},
	filters:{
		q: '',
		role_id: '',
		status_id: ''
	},
	permissions:[],
	error: undefined,
	timestamp: undefined
}

const notifications_types = (state = notificationTypiInit, action) => {
	switch (action.type){
		case NOTIFICATION_TYPE_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case NOTIFICATION_TYPE_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				list: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case NOTIFICATION_TYPE_EDIT:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				permissions: action.permissions,
				timestamp: action.timestamp
			}
		case NOTIFICATION_TYPE_CLEAR:
			return {
				...state,
				edit: action.payload,
				timestamp: action.timestamp
			}
		case NOTIFICATION_TYPE_FAIL:
			return {
				...state,
				isFetching: action.isFetching,
				error: action.error,
				timestamp: action.timestamp
			}
		default:
			return{
				...state
			}
	}
}

export default notifications_types;




// WEBPACK FOOTER //
// ./src/reducers/notifications_types.js